import React from "react"
import { useSelector } from "react-redux"

import {
    StoreType,
    SilDeviceType,
    SilDeviceNestedType,
} from "client/store"
import {
    TableWrapper,
    TableScroller,
    TableContentWrapper,
    TableRow,
    TableHeaderCell,
    TableCell,
    TableCellContentWrapper,
    TableCellContent,
} from "client/components"

import Columns from "client/pages/sil/device/subsystemEdit/columns"

interface CalculatedDataProps {
    existingSubsystem: SilDeviceType
    updatedSubsystem: SilDeviceType
    nestedDevices: readonly SilDeviceNestedType[]
}

const rowSize = "sm"

const CalculatedData = ({
    existingSubsystem,
    updatedSubsystem,
    nestedDevices,
}: CalculatedDataProps) => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    const columns = Columns()
    let counter = 0
    const columnLength = (nestedDevices && nestedDevices.length) + (existingSubsystem.id ? 2 : 1)
    const style: React.CSSProperties = { width: `${100 / columnLength}%` }

    return (
        <TableWrapper>
            <TableScroller>
                <TableContentWrapper inverted>
                    <thead>
                        <TableRow inverted noHover size={rowSize}>
                            <TableHeaderCell cellWidth="200px">{lang.item}</TableHeaderCell>
                            {
                                columns.map((column) => (
                                    <TableHeaderCell
                                        key={column.field}
                                        cellWidth="200px"
                                    >
                                        {column.header}
                                    </TableHeaderCell>
                                ))
                            }
                        </TableRow>
                    </thead>

                    <tbody>
                        {
                            existingSubsystem && (
                                <TableRow
                                    inverted
                                    noHover
                                    size={rowSize}
                                    style={style}
                                >
                                    <TableCell>
                                        <TableCellContentWrapper>
                                            <TableCellContent>
                                                {lang.existingSubsystem}
                                            </TableCellContent>
                                        </TableCellContentWrapper>
                                    </TableCell>
                                    {
                                        columns.map((column) => (
                                            <TableCell key={column.field}>
                                                <TableCellContentWrapper>
                                                    <TableCellContent>
                                                        {
                                                            column.formatter
                                                                ? column.formatter(existingSubsystem)
                                                                : existingSubsystem[column.field as keyof SilDeviceType]
                                                        }
                                                    </TableCellContent>
                                                </TableCellContentWrapper>
                                            </TableCell>
                                        ))
                                    }
                                </TableRow>
                            )
                        }

                        {
                            existingSubsystem
                            && updatedSubsystem && (
                                <TableRow
                                    inverted
                                    noHover
                                    size={rowSize}
                                    style={style}
                                >
                                    <TableCell>
                                        <TableCellContentWrapper>
                                            <TableCellContent>
                                                {lang.subsystem}
                                            </TableCellContent>
                                        </TableCellContentWrapper>
                                    </TableCell>
                                    {
                                        columns.map((column) => {
                                            const existingData = existingSubsystem[column.field as keyof SilDeviceType]
                                            const updatedData = updatedSubsystem[column.field as keyof SilDeviceType]
                                            return (
                                                <TableCell
                                                    key={column.field}
                                                    dangerType={
                                                        existingSubsystem
                                                        && existingData !== updatedData
                                                    }
                                                >
                                                    <TableCellContentWrapper>
                                                        <TableCellContent>
                                                            {
                                                                column.formatter
                                                                    ? column.formatter(updatedSubsystem)
                                                                    : updatedSubsystem[column.field as keyof SilDeviceType]
                                                            }
                                                        </TableCellContent>
                                                    </TableCellContentWrapper>
                                                </TableCell>
                                            )
                                        })
                                    }
                                </TableRow>
                            )
                        }

                        {
                            nestedDevices && nestedDevices.map((nested) => {
                                if (nested) counter += 1
                                return nested && (
                                    <TableRow
                                        key={counter}
                                        inverted
                                        noHover
                                        size={rowSize}
                                        style={style}
                                    >
                                        <TableCell>
                                            <TableCellContentWrapper>
                                                <TableCellContent>
                                                    {`${lang.device} ${counter}`}
                                                </TableCellContent>
                                            </TableCellContentWrapper>
                                        </TableCell>
                                        {
                                            columns.map((column) => (
                                                <TableCell key={column.field}>
                                                    <TableCellContentWrapper>
                                                        <TableCellContent>
                                                            {
                                                                column.formatter
                                                                    ? column.formatter(nested)
                                                                    : nested[column.field as keyof SilDeviceNestedType]
                                                            }
                                                        </TableCellContent>
                                                    </TableCellContentWrapper>
                                                </TableCell>
                                            ))
                                        }
                                    </TableRow>
                                )
                            })
                        }
                    </tbody>
                </TableContentWrapper>
            </TableScroller>
        </TableWrapper>
    )
}
export default CalculatedData
